"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tauntSpellsList = exports.healingSpellsList = exports.spells = exports.spellsBase = exports.gunStartingLevels = exports.gunLevels = void 0;
const constants_1 = __importDefault(require("../../../../shared/constants"));
const spellAnimSettings_1 = require("../../../mageclash/shared/pickups/spellAnimSettings");
const config_1 = require("../../config");
exports.gunLevels = 100;
exports.gunStartingLevels = {
    minigun: 2000,
    shotgun: 3000,
    sniper: 4000,
    burstRifle: 5000,
};
const audio = {
    fireball: {
        'cast': 'firebolt-cast',
        'impact': 'firebolt-explode',
    },
    frostbolt: {
        'cast': 'frostbolt-2',
        'impact': 'frostbolt-explode',
    },
    windbolt: {
        'cast': 'windbolt-cast',
        'impact': 'windbolt-explode',
    },
    gravityBall: {
        'cast': 'gravity-cast',
        'impact': 'gravity-explode',
    },
    dash: {
        'cast': 'dash-normal',
        'impact': 'frostbolt',
    }
};
const bubbleSpells = {
    skeleton: {
        'name': 'Bubbles',
        'rarity': 'uncommon',
        'mana': 'water',
        'manaCost': 2,
        'radius': 3,
        'speed': 100,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 5,
        'spread': 1.6,
        'randomSpreadFactor': 2,
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 600 },
        'chargeCooldown': null,
        'damage': 4,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'bubble',
            'impact': 'bubble-pop',
        },
        'imgPath': 'bubbles.png',
        atlas: true,
        'spriteName': 'bubble.png',
        'noAnim': true
    },
    variations: [
        {
            spellID: 93,
            rarity: 'uncommon',
            bullets: 5,
            damage: 4
        },
        {
            spellID: 94,
            rarity: 'rare',
            bullets: 6,
            damage: 5
        },
        {
            spellID: 95,
            rarity: 'epic',
            bullets: 7,
            damage: 6
        },
        {
            spellID: 96,
            rarity: 'legendary',
            bullets: 9,
            damage: 7
        },
        {
            name: 'Flower Bubbles',
            spellID: 441,
            rarity: 'uncommon',
            bullets: 5,
            damage: 2
        },
    ]
};
const netSpells = {
    skeleton: {
        'spellID': 10000,
        'name': 'Net',
        'rarity': 'rare',
        'mana': 'air',
        'manaCost': null,
        'tier': 'normal',
        'radius': 6,
        'speed': 250,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 0,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': audio.windbolt,
        'imgPath': 'fishing-net.png',
        atlas: true,
        'spriteName': 'fishing-net-common.png',
        'noAnim': true,
        scale: {
            scaleX: 1.35,
            scaleY: 1.35,
            duration: 300,
            repeat: 0,
            yoyo: true
        },
    },
    variations: [
        {
            spellID: 10000,
            name: 'Beginner Net',
            rarity: 'common',
            damage: 0,
            // spellCooldown: 0.35, // for debugging
            resourceCost: {
                resource: 'commonNet',
                cost: 1
            },
            'spriteName': 'fishing-net-common.png',
        },
        {
            spellID: 10001,
            name: 'Adept Net',
            rarity: 'uncommon',
            resourceCost: {
                resource: 'uncommonNet',
                cost: 1
            },
            'spriteName': 'fishing-net-uncommon.png',
        },
        {
            spellID: 10002,
            name: 'Master Net',
            rarity: 'rare',
            resourceCost: {
                resource: 'rareNet',
                cost: 1
            },
            'spriteName': 'fishing-net-rare.png',
        },
        {
            spellID: 10008,
            name: 'Net Master Net',
            rarity: 'rare',
            'spriteName': 'fishing-net-rare.png',
        },
        // {
        //     spellID: 10003,
        //     name: 'Epic Net',
        //     rarity: 'epic',
        //     resourceCost: {
        //         resource: 'epicNet',
        //         cost: 1
        //     },
        //     'spriteName': 'fishing-net-epic.png',
        // },
        // {
        //     spellID: 10004,
        //     name: 'Legendary Net',
        //     rarity: 'legendary',
        //     resourceCost: {
        //         resource: 'legendaryNet',
        //         cost: 1
        //     },
        //     'spriteName': 'fishing-net-legendary.png',
        // },
    ]
};
const meteorSpells = {
    skeleton: {
        'name': 'Meteor',
        'rarity': 'epic',
        'mana': 'fire',
        'manaCost': 3,
        'radius': 9,
        'speed': 100,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 35,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': audio.fireball,
        'imgPath': 'burning-meteor.png',
        'spriteName': 'projectile17',
    },
    variations: [
        {
            spellID: 2,
            rarity: 'epic',
            damage: 35
        },
        {
            spellID: 36,
            rarity: 'legendary',
            damage: 45
        },
        {
            name: 'Triple Meteor',
            rarity: 'legendary',
            spellID: 92,
            manaCost: 4,
            radius: 10,
            speed: 70,
            spellCooldown: 2.5,
            type: 'multi',
            bullets: 3,
            spread: 15,
            damage: 25,
            imgPath: 'triple-meteor.png'
        },
        {
            spellID: 407,
            name: 'Dragon Meteor',
            rarity: 'epic',
            speed: 120,
            radius: 20,
            manaCost: 3,
            spellCooldown: 3,
            damage: 50,
            health: 125
        },
        {
            spellID: 425,
            name: 'Dark Wiz Meteor',
            rarity: 'legendary',
            speed: 70,
            radius: 8,
            manaCost: 3,
            spellCooldown: 2.5,
            damage: 20,
        },
        {
            spellID: 436,
            name: 'Triple Dark Wiz Meteor',
            rarity: 'legendary',
            speed: 70,
            radius: 10,
            manaCost: 3,
            spellCooldown: 2.5,
            damage: 20,
            type: 'multi',
            bullets: 3,
            spread: 15,
        },
        {
            spellID: 437,
            name: 'Triple Dark Mega Mini Balls',
            rarity: 'legendary',
            speed: 70,
            radius: 4,
            manaCost: 3,
            spellCooldown: 10,
            damage: 6,
            randomSpreadFactor: 1,
            type: 'multi',
            bullets: 16,
            spread: 3,
            minTimeEngaged: 6,
        },
    ]
};
const daggers = {
    skeleton: {
        'spellID': 214,
        'name': 'Dagger',
        'rarity': 'uncommon',
        dropType: 'dagger',
        'mana': null,
        'manaCost': null,
        spawnOffset: 7,
        tweenType: 'dagger',
        'radius': 18,
        'speed': null,
        'spellCooldown': 0.25,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 4,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'dagger.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_0',
        animSettings: spellAnimSettings_1.animSettings.dagger,
    },
    variations: [
        {
            spellID: 214,
            rarity: 'uncommon',
            damage: 4,
        },
        {
            spellID: 215,
            rarity: 'rare',
            damage: 6,
        },
        {
            spellID: 216,
            rarity: 'epic',
            damage: 9,
        },
        {
            spellID: 217,
            rarity: 'legendary',
            damage: 11,
        },
        {
            spellID: 221,
            rarity: 'uncommon',
            name: 'Ice Dagger',
            damage: 3,
            effects: ['slow'],
            imgPath: 'dagger-ice.png',
            atlasTexture: 'Sword sheet_11',
        },
        {
            spellID: 222,
            rarity: 'rare',
            name: 'Ice Dagger',
            damage: 5,
            effects: ['slow'],
            imgPath: 'dagger-ice.png',
            atlasTexture: 'Sword sheet_11',
        },
        {
            spellID: 223,
            rarity: 'epic',
            name: 'Ice Dagger',
            damage: 7,
            effects: ['slow'],
            imgPath: 'dagger-ice.png',
            atlasTexture: 'Sword sheet_11',
        },
        {
            spellID: 224,
            rarity: 'legendary',
            name: 'Ice Dagger',
            damage: 9,
            effects: ['slow'],
            imgPath: 'dagger-ice.png',
            atlasTexture: 'Sword sheet_11',
        },
        {
            spellID: 212,
            rarity: 'legendary',
            name: 'Flame',
            damage: 12,
            effects: [],
            imgPath: 'flame-dagger.png',
            atlasTexture: 'The Flame',
            animSettings: spellAnimSettings_1.animSettings.flame
        },
        {
            spellID: 930,
            rarity: 'common',
            damage: 4,
            tier: 0
        },
        {
            spellID: 931,
            rarity: 'common',
            damage: 5,
            tier: 1
        },
        {
            spellID: 932,
            rarity: 'uncommon',
            damage: 6,
            tier: 2
        },
        {
            spellID: 933,
            rarity: 'uncommon',
            damage: 7,
            tier: 3
        },
        {
            spellID: 934,
            rarity: 'uncommon',
            damage: 8,
            tier: 4
        },
        {
            spellID: 935,
            rarity: 'rare',
            damage: 9,
            tier: 5
        },
        {
            spellID: 936,
            rarity: 'rare',
            damage: 10,
            tier: 6
        },
        {
            spellID: 937,
            rarity: 'rare',
            damage: 11,
            tier: 7
        },
        {
            spellID: 938,
            rarity: 'epic',
            damage: 12,
            tier: 8
        },
        {
            spellID: 939,
            rarity: 'epic',
            damage: 13,
            tier: 9
        },
    ]
};
const bindingShotSpells = {
    skeleton: {
        'spellID': 67,
        'name': 'Binding Shot',
        'rarity': 'uncommon',
        'mana': 'earth',
        'manaCost': 2,
        'radius': 6,
        'speed': 200,
        'spellCooldown': 1.25,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 12,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['root'],
        'effectsDuration': { root: 15 },
        'audio': {
            'cast': 'rootshot-cast',
            'impact': 'root-impact',
        },
        'imgPath': 'binding-shot.png',
        'spriteName': 'projectile9green',
    },
    variations: [
        {
            spellID: 67,
            rarity: 'uncommon',
            damage: 12,
        },
        {
            spellID: 68,
            rarity: 'rare',
            damage: 20,
        },
        {
            spellID: 69,
            rarity: 'epic',
            damage: 27,
        },
        {
            spellID: 70,
            rarity: 'legendary',
            damage: 33,
        },
        {
            spellID: 467,
            name: 'Crab Triple Binding Shot',
            rarity: 'uncommon',
            damage: 10,
            type: 'multi',
            bullets: 3,
            spread: 6,
        },
        {
            spellID: 461,
            name: 'Jackocharlie Quintuple Binding Shot',
            rarity: 'legendary',
            damage: 10,
            health: 125,
            speed: 250,
            effectsDuration: { root: 15 },
            spellCooldown: 1.5,
            type: 'multi',
            bullets: 5,
            spread: 10,
        }
    ]
};
const darkHoleSpells = {
    skeleton: {
        'spellID': 71,
        'name': 'Dark Hole',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 6,
        'radius': 30,
        'speed': 0,
        'spellCooldown': 4,
        'cooldownCounter': 0,
        'type': 'static',
        'staticFrame': 2,
        'chargeCooldown': 0.5,
        'damage': 25,
        'selfDamage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        // 'lockPlayer': true,
        'effects': ['gravity'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'gravity-compress',
            'prep': 'gravity-pull',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3black',
    },
    variations: [
        {
            spellID: 71,
            rarity: 'rare',
            damage: 25,
            selfDamage: 10,
        },
        {
            spellID: 72,
            rarity: 'epic',
            damage: 35,
            selfDamage: 18
        },
        {
            spellID: 73,
            rarity: 'legendary',
            damage: 45,
            selfDamage: 27
        },
        {
            spellID: 468,
            name: 'DarkWiz Dark Hole',
            rarity: 'rare',
            damage: 20,
            selfDamage: 0,
        },
        {
            spellID: 428,
            name: 'Melee Boss Dark Hole',
            rarity: 'rare',
            damage: 20,
            radius: 30,
            spellCooldown: 3.5,
        },
        {
            spellID: 464,
            name: 'Jackocharlie Dark Hole',
            rarity: 'rare',
            damage: 20,
            radius: 30,
            spellCooldown: 3.5,
        },
    ]
};
const healingCircleSpells = {
    skeleton: {
        'spellID': 32,
        'name': 'Healing Circle',
        'rarity': 'uncommon',
        'mana': 'light',
        'manaCost': 2,
        'radius': 10,
        'speed': 0,
        'spellCooldown': 7,
        'cooldownCounter': 0,
        'type': 'static',
        'staticFrame': 4,
        'chargeCooldown': 0.75,
        'damage': -40,
        'healingSpell': true,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': null,
            'impact': 'heal',
            'prep': 'water-bubble'
        },
        'imgPath': 'heal.png',
        'spriteName': 'explosion2',
        dropType: 'tome'
    },
    variations: [
        {
            spellID: 32,
            rarity: 'uncommon',
            damage: -40,
            radius: 10
        },
        {
            spellID: 33,
            rarity: 'rare',
            damage: -55,
            radius: 14
        },
        {
            spellID: 34,
            rarity: 'epic',
            damage: -70,
            radius: 18
        },
        {
            spellID: 35,
            rarity: 'legendary',
            damage: -90,
            radius: 22
        },
        {
            spellID: 85,
            name: 'Heal Self',
            rarity: 'uncommon',
            dropType: 'tome',
            damage: -25,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 10,
            imgPath: 'healing.png',
        },
        {
            spellID: 86,
            name: 'Heal Self',
            rarity: 'rare',
            dropType: 'tome',
            damage: -33,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 10,
            imgPath: 'healing.png',
        },
        {
            spellID: 87,
            name: 'Heal Self',
            rarity: 'epic',
            dropType: 'tome',
            damage: -40,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 10,
            imgPath: 'healing.png',
        },
        {
            spellID: 88,
            name: 'Heal Self',
            rarity: 'legendary',
            dropType: 'tome',
            damage: -50,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 10,
            imgPath: 'healing.png',
        },
        {
            spellID: 950,
            name: 'Pet Heal Effect',
            rarity: 'common',
            dropType: 'tome',
            damage: 0,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
        },
        {
            spellID: 951,
            name: 'Pet Slime Heal',
            rarity: 'common',
            dropType: 'tome',
            damage: -250,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            imgPath: 'healing.png',
        },
        {
            spellID: 952,
            name: 'Pet Critter Buff',
            rarity: 'common',
            dropType: 'tome',
            damage: 0,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            tint: 0x77c2fd,
            imgPath: 'healing.png',
        },
        {
            spellID: 953,
            name: 'Pet Lava Slime Buff',
            rarity: 'common',
            dropType: 'tome',
            damage: 0,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            tint: 0x7c2727,
            imgPath: 'healing.png',
        },
        {
            spellID: 954,
            name: 'Pet Ice Slime Buff',
            rarity: 'common',
            dropType: 'tome',
            damage: 0,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            tint: 0x0048ba,
            imgPath: 'healing.png',
        },
        {
            spellID: 955,
            name: 'Pet Seahorse Buff',
            rarity: 'common',
            dropType: 'tome',
            damage: 0,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            tint: 0x5f6ff2,
            imgPath: 'healing.png',
        },
        {
            spellID: 956,
            name: 'Pet Starfish Heal',
            rarity: 'common',
            dropType: 'tome',
            damage: -100,
            type: 'self',
            playImmediately: true,
            chargeCooldown: 0,
            radius: 60,
            imgPath: 'healing.png',
        },
        {
            spellID: 850,
            name: 'Heal',
            rarity: 'common',
            dropType: 'tome',
            damage: -25,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 0
        },
        {
            spellID: 851,
            name: 'Heal',
            rarity: 'uncommon',
            dropType: 'tome',
            damage: -30,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 1
        },
        {
            spellID: 852,
            name: 'Heal',
            rarity: 'uncommon',
            dropType: 'tome',
            damage: -35,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 2
        },
        {
            spellID: 853,
            name: 'Heal',
            rarity: 'rare',
            dropType: 'tome',
            damage: -40,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 3
        },
        {
            spellID: 854,
            name: 'Heal',
            rarity: 'rare',
            dropType: 'tome',
            damage: -45,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 4
        },
        {
            spellID: 855,
            name: 'Heal',
            rarity: 'epic',
            dropType: 'tome',
            damage: -50,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 5
        },
        {
            spellID: 856,
            name: 'Heal',
            rarity: 'legendary',
            dropType: 'tome',
            damage: -55,
            playImmediately: true,
            chargeCooldown: 0,
            radius: 20,
            imgPath: 'healing.png',
            tier: 6
        },
    ]
};
const iceBoltSpells = {
    skeleton: {
        'mana': 'water',
        'manaCost': 2,
        'radius': 6,
        'speed': 200,
        'spellCooldown': 0.75,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': audio.frostbolt,
        'imgPath': 'ice-bolt.png',
        'spriteName': 'projectile19',
    },
    variations: [
        {
            spellID: 5,
            name: 'Ice Bolt',
            rarity: 'rare',
            damage: 12
        },
        {
            spellID: 49,
            name: 'Ice Bolt',
            rarity: 'epic',
            damage: 18
        },
        {
            spellID: 50,
            name: 'Ice Bolt',
            rarity: 'legendary',
            damage: 22
        },
        {
            spellID: 46,
            name: 'Double Ice Bolt',
            rarity: 'rare',
            damage: 8,
            type: 'multi',
            bullets: 2,
            spread: 7,
            imgPath: 'double-ice-bolt.png',
        },
        {
            spellID: 47,
            name: 'Double Ice Bolt',
            rarity: 'epic',
            type: 'multi',
            damage: 11,
            bullets: 2,
            spread: 7,
            imgPath: 'double-ice-bolt.png',
        },
        {
            spellID: 48,
            name: 'Double Ice Bolt',
            rarity: 'legendary',
            type: 'multi',
            damage: 14,
            bullets: 2,
            spread: 7,
            imgPath: 'double-ice-bolt.png',
        },
        {
            spellID: 30,
            name: 'Triple Ice Bolt',
            rarity: 'epic',
            type: 'multi',
            damage: 8,
            bullets: 3,
            spread: 10,
            imgPath: 'double-ice-bolt.png',
        },
        {
            spellID: 31,
            name: 'Quintuple Ice Bolt',
            rarity: 'legendary',
            type: 'multi',
            damage: 4,
            bullets: 5,
            spread: 10,
            imgPath: 'quintuple-ice-bolt.png',
        },
        {
            spellID: 450,
            name: 'Slime Ice Bolt',
            rarity: 'rare',
            damage: 22,
            spellCooldown: 2,
        },
        {
            spellID: 451,
            name: 'Ice Slime Ice Barrage',
            rarity: 'rare',
            type: 'multi',
            spellCooldown: 2.5,
            radius: 3,
            speed: 135,
            damage: 4,
            bullets: 20,
            spread: 2,
            health: 50,
            imgPath: 'double-ice-bolt.png',
            minTimeEngaged: 6,
        },
        {
            spellID: 453,
            name: 'Slime Triple Ice Bolt',
            rarity: 'rare',
            type: 'multi',
            damage: 6,
            bullets: 3,
            spread: 7,
            spellCooldown: 2,
            imgPath: 'double-ice-bolt.png',
        },
        {
            spellID: 460,
            name: 'Ice Golem Boss Quintuple Ice Bolt',
            rarity: 'legendary',
            type: 'multi',
            damage: 4,
            bullets: 5,
            spread: 10,
            spellCooldown: .75,
            manaCost: 3,
            imgPath: 'quintuple-ice-bolt.png',
        },
        {
            spellID: 409,
            name: 'Ice Golem Ice Bolt Multi',
            rarity: 'rare',
            type: 'multi',
            damage: 8,
            bullets: 9,
            spread: 7,
            spellCooldown: .75,
            speed: 250,
            manaCost: 3,
            imgPath: 'quintuple-ice-bolt.png',
        },
        {
            spellID: 448,
            name: 'Ice Golem Attack',
            rarity: 'rare',
            radius: 6.5,
            spellCooldown: 1,
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 11
        },
    ]
};
const fireballSpells = {
    skeleton: {
        'spellID': 1,
        'name': 'Fireball',
        'rarity': 'rare',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 6,
        'speed': 200,
        'spellCooldown': 0.5,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': audio.fireball,
        'imgPath': 'fireball.png',
        'spriteName': 'projectile15',
    },
    variations: [
        {
            spellID: 1,
            name: 'Fireball',
            rarity: 'rare',
            damage: 10,
            radius: 6,
            speed: 200
        },
        {
            spellID: 51,
            name: 'Fireball',
            rarity: 'epic',
            damage: 16,
            radius: 6,
            speed: 200
        },
        {
            spellID: 52,
            name: 'Fireball',
            rarity: 'legendary',
            damage: 20,
            radius: 6,
            speed: 200
        },
        {
            spellID: 11,
            name: 'Fire Shot',
            rarity: 'uncommon',
            damage: 6,
            radius: 3,
            spellCooldown: 0.4,
            speed: 225
        },
        {
            spellID: 43,
            name: 'Double Fireball',
            rarity: 'rare',
            damage: 7,
            radius: 6,
            speed: 200,
            type: 'multi',
            bullets: 3,
            spread: 10,
            imgPath: 'double-fireball.png',
        },
        {
            spellID: 44,
            name: 'Double Fireball',
            rarity: 'epic',
            damage: 9,
            radius: 6,
            speed: 200,
            type: 'multi',
            bullets: 3,
            spread: 10,
            imgPath: 'double-fireball.png',
        },
        {
            spellID: 45,
            name: 'Double Fireball',
            rarity: 'legendary',
            damage: 11,
            radius: 6,
            speed: 200,
            type: 'multi',
            bullets: 3,
            spread: 10,
            imgPath: 'double-fireball.png',
        },
        {
            spellID: 26,
            name: 'Triple Fireball',
            rarity: 'rare',
            damage: 6,
            radius: 6,
            speed: 200,
            type: 'multi',
            bullets: 3,
            spread: 10,
            imgPath: 'triple-fireball.png',
        },
        {
            spellID: 27,
            name: 'Quintuple Fireball',
            rarity: 'legendary',
            damage: 6,
            radius: 6,
            speed: 200,
            type: 'multi',
            bullets: 5,
            spread: 10,
            spellCooldown: 0.5,
            imgPath: 'quintuple-fireball.png',
        },
        {
            spellID: 403,
            name: 'Dark Wiz Fireball',
            rarity: 'rare',
            damage: 5,
            radius: 6,
            speed: 120,
            spellCooldown: 4
        },
        {
            spellID: 415,
            name: 'Baby Dragon Whelp Attack',
            rarity: 'rare',
            radius: 5.5,
            speed: 180,
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 8,
            spellCooldown: 1.4,
        },
        {
            spellID: 404,
            name: 'Dragon Whelp Attack',
            rarity: 'rare',
            radius: 6.5,
            speed: 180,
            type: 'multi',
            bullets: 5,
            spread: 7,
            damage: 11,
            spellCooldown: 1.3,
        },
        {
            spellID: 405,
            name: 'Cannon Fireball',
            rarity: 'rare',
            radius: 5,
            spellCooldown: 1.5,
            damage: 10,
            speed: 200
        },
        {
            spellID: 439,
            name: 'Boss Cannon Fireball',
            rarity: 'rare',
            radius: 25,
            spellCooldown: 1.5,
            damage: 40,
            speed: 150
        },
        {
            spellID: 440,
            name: 'Triple Boss Cannon Fireball',
            rarity: 'rare',
            damage: 20,
            health: 40,
            radius: 20,
            speed: 150,
            type: 'multi',
            bullets: 3,
            spread: 25,
            imgPath: 'triple-fireball.png',
            minTimeEngaged: 3,
            spellCooldown: 3.5,
        },
        {
            spellID: 406,
            name: 'Dragon Fire',
            rarity: 'rare',
            radius: 6.5,
            speed: 145,
            type: 'multi',
            bullets: 9,
            spread: 7,
            damage: 10,
            health: 50,
            spellCooldown: 2.5,
        },
        {
            spellID: 432,
            name: 'Lava Slime Mega Shot',
            rarity: 'rare',
            radius: 6,
            speed: 100,
            type: 'multi',
            bullets: 18,
            spread: 20,
            damage: 15,
            spellCooldown: 8,
            minTimeEngaged: 4,
        },
        {
            spellID: 433,
            name: 'Lava Slime Fire Barrage',
            rarity: 'rare',
            radius: 3,
            speed: 135,
            type: 'multi',
            bullets: 20,
            spread: 2,
            damage: 5,
            health: 50,
            spellCooldown: 2.5,
            minTimeEngaged: 6,
        },
    ]
};
const fireSpraySpells = {
    skeleton: {
        'spellID': 60,
        'name': 'Fire Spray',
        'rarity': 'rare',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 6,
        'speed': 200,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 20,
        'spread': 1,
        'randomSpreadFactor': 1,
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 1000 },
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': audio.fireball,
        'imgPath': 'fireball.png',
        'spriteName': 'projectile25',
    },
    variations: [
        {
            spellID: 60,
            name: 'Fire Spray',
            rarity: 'rare',
            bullets: 20,
            spread: 1,
            randomSpreadFactor: 1,
            randomBulletDelay: { min: 0, max: 1000 },
            damage: 10,
        },
        {
            spellID: 61,
            name: 'Fire Blast',
            rarity: 'rare',
            damage: 10,
            bullets: 7,
            spellCooldown: 0.5,
            duration: 0.2,
            randomSpreadFactor: 2,
            randomBulletDelay: { min: 0, max: 200 },
        },
        {
            spellID: 90,
            name: 'Fire Stream',
            rarity: 'epic',
            manaCost: 3,
            bullets: 7,
            spread: .75,
            randomSpreadFactor: .75,
            maxDistance: 100,
            spellCooldown: 2,
            randomBulletDelay: { min: 0, max: 600 },
            damage: 8,
            imgPath: 'fire-tail.png',
        },
        {
            spellID: 91,
            name: 'Fire Stream',
            rarity: 'legendary',
            manaCost: 3,
            bullets: 8,
            spread: .75,
            randomSpreadFactor: .75,
            maxDistance: 100,
            spellCooldown: 2,
            randomBulletDelay: { min: 0, max: 600 },
            damage: 10,
            imgPath: 'fire-tail.png',
        },
        {
            spellID: 438,
            name: 'Hellhound Fire Stream',
            rarity: 'rare',
            manaCost: 2,
            bullets: 8,
            spread: .75,
            randomSpreadFactor: .75,
            spellCooldown: 2,
            randomBulletDelay: { min: 0, max: 600 },
            damage: 10,
            imgPath: 'fire-tail.png',
        }
    ]
};
const dashSpells = {
    skeleton: {
        'name': 'Dash',
        'rarity': 'common',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        'radius': null,
        'speed': null,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'movement',
        'chargeCooldown': null,
        'damage': null,
        'speedBoost': 130,
        'sprintTicks': 5,
        'effects': [],
        'audio': audio.dash,
        'imgPath': 'dash.png',
    },
    variations: [
        {
            spellID: 300,
            rarity: 'common'
        },
        {
            spellID: 301,
            rarity: 'uncommon',
            'sprintTicks': 6,
        },
        {
            spellID: 302,
            rarity: 'rare',
            'speedBoost': 140,
            'sprintTicks': 8,
        },
        {
            spellID: 303,
            rarity: 'epic',
            'speedBoost': 145,
            'sprintTicks': 10,
        },
        {
            spellID: 304,
            rarity: 'legendary',
            'speedBoost': 150,
            'sprintTicks': 10,
        },
        {
            spellID: 316,
            name: 'Gravity Dash',
            rarity: 'rare',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 420,
        },
        {
            spellID: 317,
            name: 'Gravity Dash',
            rarity: 'epic',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 420,
        },
        {
            spellID: 318,
            name: 'Gravity Dash',
            rarity: 'legendary',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 420,
        },
        {
            spellID: 320,
            name: 'Fire Dash',
            rarity: 'rare',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 78,
        },
        {
            spellID: 321,
            name: 'Fire Dash',
            rarity: 'epic',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 79,
        },
        {
            spellID: 322,
            name: 'Fire Dash',
            rarity: 'legendary',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 80,
        },
        {
            spellID: 324,
            name: 'Water Dash',
            rarity: 'rare',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 75,
        },
        {
            spellID: 325,
            name: 'Water Dash',
            rarity: 'epic',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 3
        },
        {
            spellID: 326,
            name: 'Water Dash',
            rarity: 'epic',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 76
        },
        {
            spellID: 328,
            name: 'Earth Dash',
            rarity: 'rare',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 82,
        },
        {
            spellID: 329,
            name: 'Earth Dash',
            rarity: 'epic',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 83,
        },
        {
            spellID: 330,
            name: 'Earth Dash',
            rarity: 'legendary',
            speedBoost: 140,
            sprintTicks: 8,
            spellCooldown: 3,
            createSpell: 84,
        },
        {
            spellID: 650,
            rarity: 'common',
            tier: 0,
            dropType: 'dash',
        },
        {
            spellID: 651,
            rarity: 'uncommon',
            'sprintTicks': 6,
            tier: 1,
            dropType: 'dash',
        },
        {
            spellID: 652,
            rarity: 'uncommon',
            'speedBoost': 140,
            'sprintTicks': 8,
            tier: 2,
            dropType: 'dash',
        },
        {
            spellID: 653,
            rarity: 'rare',
            'speedBoost': 145,
            'sprintTicks': 10,
            tier: 3,
            dropType: 'dash',
        },
        {
            spellID: 654,
            rarity: 'rare',
            'speedBoost': 150,
            'sprintTicks': 12,
            tier: 4,
            dropType: 'dash',
        },
        {
            spellID: 655,
            rarity: 'epic',
            'speedBoost': 155,
            'sprintTicks': 14,
            tier: 5,
            dropType: 'dash',
        },
        {
            spellID: 656,
            rarity: 'legendary',
            'speedBoost': 160,
            'sprintTicks': 16,
            tier: 6,
            dropType: 'dash',
        },
    ]
};
const teleportSpells = {
    skeleton: {
        'name': 'Teleport',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        'radius': null,
        'speed': null,
        'spellCooldown': 7,
        'cooldownCounter': 0,
        'type': 'movement',
        'chargeCooldown': null,
        'damage': null,
        'speedBoost': 500,
        'sprintTicks': 2,
        'effects': [],
        'audio': {
            'cast': 'teleport-12',
            'impact': 'frostbolt',
        },
        'imgPath': 'teleport.png',
    },
    variations: [
        {
            spellID: 305,
            rarity: 'epic'
        },
        {
            spellID: 306,
            'speedBoost': 600,
            rarity: 'legendary'
        },
    ]
};
const chargeSpells = {
    skeleton: {
        'name': 'Charge',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        'radius': null,
        'speed': null,
        'spellCooldown': 5,
        'cooldownCounter': 0,
        'type': 'movement',
        'chargeCooldown': null,
        'speedBoost': 130,
        'sprintTicks': 8,
        'effects': [],
        'chargeAttack': true,
        'damage': 15,
        'audio': audio.dash,
        'imgPath': 'charge.png',
    },
    variations: [
        {
            spellID: 307,
            rarity: 'uncommon',
            damage: 15
        },
        {
            spellID: 308,
            rarity: 'rare',
            damage: 22
        },
        {
            spellID: 309,
            rarity: 'epic',
            damage: 30
        },
        {
            spellID: 310,
            rarity: 'legendary',
            damage: 35
        },
        {
            spellID: 422,
            name: 'Slime Charge',
            rarity: 'uncommon',
            damage: 10,
            spellCooldown: 5,
            speedBoost: 130,
            sprintTicks: 8,
            minTimeEngaged: 4
        },
        {
            spellID: 429,
            name: 'Hellhound Charge',
            rarity: 'epic',
            damage: 30,
            spellCooldown: 5,
            speedBoost: 130,
            sprintTicks: 20,
            minTimeEngaged: 4
        },
        {
            spellID: 465,
            name: 'Jackocharlie Charge',
            rarity: 'epic',
            damage: 10,
            spellCooldown: 5,
            speedBoost: 130,
            sprintTicks: 20,
            minTimeEngaged: 4
        },
    ]
};
const stealthSpells = {
    skeleton: {
        'spellID': 311,
        'name': 'Stealth',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        'radius': null,
        'speed': null,
        'spellCooldown': 7,
        'cooldownCounter': 0,
        'type': 'movement',
        'chargeCooldown': null,
        'damage': null,
        'speedBoost': 0,
        'sprintTicks': 60,
        'effects': [],
        'stealth': true,
        'damageMultiplier': 1.2,
        'audio': {
            'cast': 'stealth',
            'impact': 'frostbolt',
        },
        'imgPath': 'stealth.png',
        dropType: 'stealth',
    },
    variations: [
        {
            spellID: 311,
            rarity: 'uncommon'
        },
        {
            spellID: 312,
            rarity: 'rare',
            sprintTicks: 70,
            damageMultiplier: 1.3
        },
        {
            spellID: 313,
            rarity: 'epic',
            sprintTicks: 80,
            damageMultiplier: 1.4
        },
        {
            spellID: 314,
            rarity: 'legendary',
            sprintTicks: 95,
            damageMultiplier: 1.5
        },
        {
            spellID: 750,
            rarity: 'common',
            tier: 0,
            damageMultiplier: 3,
        },
        {
            spellID: 751,
            rarity: 'uncommon',
            sprintTicks: 70,
            damageMultiplier: 4,
            tier: 1,
        },
        {
            spellID: 752,
            rarity: 'uncommon',
            sprintTicks: 75,
            damageMultiplier: 5,
            tier: 2,
        },
        {
            spellID: 753,
            rarity: 'rare',
            sprintTicks: 80,
            damageMultiplier: 6,
            tier: 3,
        },
        {
            spellID: 754,
            rarity: 'rare',
            sprintTicks: 80,
            damageMultiplier: 7,
            tier: 4,
        },
        {
            spellID: 755,
            rarity: 'epic',
            sprintTicks: 85,
            damageMultiplier: 8,
            tier: 5,
        },
        {
            spellID: 756,
            rarity: 'legendary',
            sprintTicks: 90,
            damageMultiplier: 9,
            tier: 6,
        },
    ]
};
const windBoltSpells = {
    skeleton: {
        'spellID': 10,
        'name': 'Wind Bolt',
        'rarity': 'rare',
        'mana': 'air',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 6,
        'speed': 250,
        'spellCooldown': 0.5,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 8,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['knockback'],
        'audio': audio.windbolt,
        'imgPath': 'wind-bolt.png',
        'spriteName': 'projectile24',
    },
    variations: [
        {
            spellID: 6,
            name: 'Wind Shot',
            rarity: 'uncommon',
            radius: 3,
            damage: 5,
            spellCooldown: 0.35,
            manaCost: 1,
        },
        {
            spellID: 10,
            name: 'Wind Bolt',
            rarity: 'rare',
        },
        {
            spellID: 53,
            name: 'Wind Bolt',
            rarity: 'epic',
            damage: 12,
        },
        {
            spellID: 54,
            name: 'Wind Bolt',
            rarity: 'legendary',
            damage: 15,
        },
        {
            spellID: 55,
            name: 'Double Wind Bolt',
            rarity: 'rare',
            type: 'multi',
            bullets: 2,
            spread: 7,
            damage: 5,
            imgPath: 'double-air-bolt.png',
        },
        {
            spellID: 56,
            name: 'Double Wind Bolt',
            rarity: 'epic',
            type: 'multi',
            bullets: 2,
            spread: 7,
            damage: 6,
            imgPath: 'double-air-bolt.png',
        },
        {
            spellID: 57,
            name: 'Double Wind Bolt',
            rarity: 'legendary',
            type: 'multi',
            bullets: 2,
            spread: 7,
            damage: 7,
            imgPath: 'double-air-bolt.png',
        },
        {
            spellID: 39,
            name: 'Triple Wind Shot',
            rarity: 'rare',
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 3,
            spellCooldown: 0.32,
            radius: 3,
            imgPath: 'triple-wind-shot.png',
        },
        {
            spellID: 37,
            name: 'Triple Wind Bolt',
            rarity: 'epic',
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 4,
            imgPath: 'triple-air-bolt.png',
        },
        {
            spellID: 38,
            name: 'Quintuple Wind Bolt',
            rarity: 'legendary',
            type: 'multi',
            bullets: 5,
            spread: 10,
            damage: 3,
            imgPath: 'quintuple-air-bolt.png',
        },
        {
            spellID: 411,
            name: 'Slime Wind Shot',
            rarity: 'uncommon',
            radius: 3,
            damage: 5,
            spellCooldown: 5,
            manaCost: 1,
        },
        {
            spellID: 412,
            name: 'Slime Triple Air Shot',
            rarity: 'rare',
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 5,
            spellCooldown: 0.32,
            radius: 3,
            imgPath: 'triple-wind-shot.png',
        },
        {
            spellID: 413,
            name: 'Woodland Boss Air Shot',
            rarity: 'rare',
            type: 'multi',
            bullets: 7,
            spread: 10,
            damage: 6,
            spellCooldown: 1.5,
            radius: 9,
            imgPath: 'triple-air-bolt.png',
        },
        {
            spellID: 402,
            name: 'Woodland Triple Air Shot',
            rarity: 'rare',
            type: 'multi',
            bullets: 3,
            spread: 10,
            damage: 3,
            spellCooldown: 1.5,
            radius: 3,
            imgPath: 'triple-wind-shot.png',
        },
        {
            spellID: 421,
            name: 'Slime Mega Shot',
            rarity: 'rare',
            type: 'multi',
            bullets: 18,
            spread: 20,
            damage: 5,
            spellCooldown: 8,
            radius: 6,
            speed: 100,
            imgPath: 'triple-wind-shot.png',
            minTimeEngaged: 4,
        },
        {
            spellID: 469,
            name: 'Critter Air Stream',
            rarity: 'rare',
            type: 'multi',
            manaCost: 3,
            bullets: 7,
            spread: .75,
            randomSpreadFactor: .75,
            maxDistance: 100,
            spellCooldown: 2,
            randomBulletDelay: { min: 0, max: 600 },
            damage: 8,
            // imgPath: 'fire-tail.png',
        },
    ]
};
const earthquakeSpells = {
    skeleton: {
        'spellID': 63,
        'name': 'Earthquake',
        'rarity': 'uncommon',
        dropType: 'spell',
        'mana': 'earth',
        'manaCost': 5,
        'tier': 'normal',
        'radius': 27,
        'speed': 0,
        'spellCooldown': 4.5,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 25, max: 40 },
        'yDistanceRange': { min: 25, max: 40 },
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 800 },
        'bullets': 6,
        'staticFrame': 1,
        'chargeCooldown': 0.25,
        'damage': 7,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['root'],
        'audio': {
            'cast': null,
            'prep': 'earthquake-cast',
            'impact': 'earthquake-explode',
        },
        'imgPath': 'wrath.png',
        'spriteName': 'explosion8',
    },
    variations: [
        {
            spellID: 63,
            rarity: 'uncommon'
        },
        {
            spellID: 64,
            rarity: 'rare',
            bullets: 7,
            damage: 10,
            manaCost: 10,
            radius: 30,
            'xDistanceRange': { min: 25, max: 42 },
            'yDistanceRange': { min: 25, max: 42 },
            'randomBulletDelay': { min: 0, max: 1600 },
        },
        {
            spellID: 65,
            rarity: 'epic',
            bullets: 10,
            damage: 10,
            radius: 34,
            'xDistanceRange': { min: 25, max: 50 },
            'yDistanceRange': { min: 25, max: 50 },
            'randomBulletDelay': { min: 0, max: 1900 },
        },
        {
            spellID: 66,
            rarity: 'legendary',
            damage: 10,
            radius: 34,
            bullets: 13,
            'xDistanceRange': { min: 25, max: 50 },
            'yDistanceRange': { min: 25, max: 50 },
            'randomBulletDelay': { min: 0, max: 1900 },
        },
        {
            spellID: 444,
            name: 'Crab Superior Earthquake',
            rarity: 'rare',
            cooldownCounter: 15,
            bullets: 7,
            damage: 10,
            manaCost: 15,
            radius: 30,
            'effectsDuration': { root: 15 },
            'xDistanceRange': { min: 25, max: 42 },
            'yDistanceRange': { min: 25, max: 42 },
            'randomBulletDelay': { min: 0, max: 1600 },
        },
        {
            spellID: 445,
            name: 'Crab Boss Earthquake',
            rarity: 'epic',
            cooldownCounter: 15,
            bullets: 10,
            damage: 10,
            manaCost: 15,
            radius: 34,
            'xDistanceRange': { min: 25, max: 50 },
            'yDistanceRange': { min: 25, max: 50 },
            'randomBulletDelay': { min: 0, max: 1900 },
        },
        {
            spellID: 447,
            name: 'Mammoth Superior Earthquake',
            rarity: 'rare',
            cooldownCounter: 15,
            bullets: 7,
            damage: 10,
            manaCost: 15,
            radius: 34,
            'xDistanceRange': { min: 25, max: 50 },
            'yDistanceRange': { min: 25, max: 50 },
            'randomBulletDelay': { min: 0, max: 1900 },
        },
        {
            spellID: 456,
            name: 'Mammoth Boss Earthquake',
            rarity: 'rare',
            cooldownCounter: 15,
            bullets: 10,
            damage: 15,
            manaCost: 15,
            radius: 34,
            'xDistanceRange': { min: 25, max: 50 },
            'yDistanceRange': { min: 25, max: 50 },
            'randomBulletDelay': { min: 0, max: 1900 },
        },
    ]
};
const spears = {
    skeleton: {
        'spellID': 226,
        'name': 'Spear',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 9,
        speed: 0,
        maxDistance: 50,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'melee',
        isSpear: true,
        'chargeCooldown': null,
        'damage': 14,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'stone-spear.png',
        spriteName: 'spear_1.png',
        animSettings: spellAnimSettings_1.animSettings.spear
    },
    variations: [
        {
            spellID: 226,
            rarity: 'uncommon'
        },
        {
            spellID: 227,
            rarity: 'rare',
            damage: 20,
            spellCooldown: 0.8,
        },
        {
            spellID: 228,
            name: 'Hardened Spear',
            rarity: 'epic',
            damage: 23,
            spellCooldown: 0.8,
            imgPath: 'barbed-spear.png',
            spriteName: 'spear.png',
        },
        {
            spellID: 229,
            name: 'Hardened Spear',
            rarity: 'legendary',
            damage: 29,
            spellCooldown: 0.8,
            imgPath: 'barbed-spear.png',
            spriteName: 'spear.png',
        },
        {
            spellID: 230,
            name: 'Shard',
            rarity: 'legendary',
            damage: 24,
            spellCooldown: 0.8,
            spawnOffset: 7,
            'effects': ['slow'],
            isSpear: true,
            imgPath: 'ice-spear.png',
            spriteName: 'spear_ice_2.png',
        },
    ]
};
const swords = {
    skeleton: {
        'spellID': 201,
        'name': 'Sword',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 25,
        'speed': null,
        'spellCooldown': 0.5,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'sword.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_0',
        animSettings: spellAnimSettings_1.animSettings.sword,
        dropType: 'sword'
    },
    variations: [
        {
            spellID: 201,
            rarity: 'uncommon',
            damage: 8,
        },
        {
            spellID: 208,
            rarity: 'rare',
            damage: 13,
        },
        {
            spellID: 218,
            name: 'Ice Sword',
            rarity: 'uncommon',
            damage: 8,
            'mana': 'water',
            effects: ['slow'],
            'imgPath': 'sword-ice.png',
            'spriteName': 'swords',
            'atlasTexture': 'Sword sheet_11',
        },
        {
            spellID: 219,
            name: 'Ice Sword',
            rarity: 'rare',
            damage: 11,
            'mana': 'water',
            effects: ['slow'],
            'imgPath': 'sword-ice.png',
            'spriteName': 'swords',
            'atlasTexture': 'Sword sheet_11',
        },
        {
            spellID: 900,
            rarity: 'common',
            damage: 8,
            tier: 0,
        },
        {
            spellID: 901,
            rarity: 'uncommon',
            damage: 9,
            tier: 1,
        },
        {
            spellID: 902,
            rarity: 'uncommon',
            damage: 10,
            tier: 2,
        },
        {
            spellID: 903,
            rarity: 'uncommon',
            damage: 12,
            tier: 3,
        },
        {
            spellID: 904,
            rarity: 'uncommon',
            damage: 14,
            tier: 4,
        },
        {
            spellID: 905,
            rarity: 'rare',
            damage: 16,
            tier: 5,
        },
        {
            spellID: 906,
            rarity: 'rare',
            damage: 18,
            tier: 6,
        },
        {
            spellID: 907,
            rarity: 'rare',
            damage: 20,
            tier: 7,
        },
        {
            spellID: 908,
            rarity: 'epic',
            damage: 22,
            tier: 8,
        },
        {
            spellID: 909,
            rarity: 'epic',
            damage: 24,
            tier: 9,
        },
    ]
};
const gravityBallSpells = {
    skeleton: {
        'spellID': 28,
        'name': 'Gravity Bolt',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 6,
        'speed': 150,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': 0.75,
        'damage': 0,
        'selfDamage': 0,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['gravity'],
        'audio': audio.gravityBall,
        'imgPath': 'gravity-ball.png',
        'spriteName': 'explosion9',
    },
    variations: [
        {
            spellID: 28,
            rarity: 'rare'
        },
        {
            spellID: 8,
            rarity: 'legendary',
            radius: 12,
            spellCooldown: 2.5
        },
        {
            spellID: 29,
            name: 'Triple Gravity Bolt',
            rarity: 'epic',
            type: 'multi',
            bullets: 3,
            spread: 10,
            spellCooldown: 1.5,
        },
        {
            spellID: 410,
            name: 'Dark Wizard Gravity Ball',
            rarity: 'legendary',
            radius: 12,
            spellCooldown: 2.5
        },
        {
            spellID: 435,
            name: 'Dark Wizard Boss Gravity Ball',
            rarity: 'legendary',
            type: 'multi',
            bullets: 3,
            spread: 15,
            spellCooldown: 2.5,
            minTimeEngaged: 2
        },
    ]
};
const fireChasmSpells = {
    skeleton: {
        'spellID': 78,
        'name': 'Fire Chasm',
        'rarity': 'rare',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 18,
        'speed': 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'static',
        'staticFrame': 2,
        'chargeCooldown': 0.75,
        'damage': 30,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': null,
            'impact': 'firebolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'explode.png',
        'spriteName': 'explosion4red',
    },
    variations: [
        {
            spellID: 78,
            rarity: 'rare',
            damage: 30,
        },
        {
            spellID: 79,
            rarity: 'epic',
            damage: 35,
        },
        {
            spellID: 80,
            rarity: 'legendary',
            damage: 40,
        },
        {
            spellID: 81,
            name: 'Lava slime fire chasm',
            rarity: 'uncommon',
            damage: 40,
        },
        {
            spellID: 470,
            name: 'Lava slime fire chasm ulti',
            rarity: 'rare',
            type: 'multiStatic',
            cooldownCounter: 15,
            bullets: 7,
            damage: 10,
            manaCost: 15,
            radius: 40,
            'effectsDuration': { root: 15 },
            'xDistanceRange': { min: 25, max: 42 },
            'yDistanceRange': { min: 25, max: 42 },
            'randomBulletDelay': { min: 0, max: 1600 },
        },
    ]
};
const wrathSpells = {
    skeleton: {
        'spellID': 82,
        'name': 'Wrath',
        'rarity': 'rare',
        'mana': 'earth',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 18,
        'speed': 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'static',
        'staticFrame': 2,
        'chargeCooldown': 0.75,
        'damage': 30,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['root'],
        'audio': {
            'cast': null,
            'prep': 'earthquake-cast',
            'impact': 'earthquake-explode',
        },
        'imgPath': 'wrath.png',
        'spriteName': 'explosion8',
    },
    variations: [
        {
            spellID: 82,
            rarity: 'rare',
            damage: 30,
        },
        {
            spellID: 83,
            rarity: 'epic',
            damage: 30,
        },
        {
            spellID: 84,
            rarity: 'legendary',
            damage: 30,
        },
    ]
};
const explodeSpells = {
    skeleton: {
        'spellID': 75,
        'name': 'Explode',
        'rarity': 'rare',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 23,
        'speed': 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'static',
        'staticFrame': 2,
        'chargeCooldown': 0.75,
        'damage': 30,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': {
            'cast': null,
            'impact': 'water-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'explode.png',
        'spriteName': 'explosion4',
    },
    variations: [
        {
            spellID: 75,
            rarity: 'rare',
            damage: 30,
        },
        {
            spellID: 3,
            rarity: 'epic',
            damage: 40,
        },
        {
            spellID: 76,
            rarity: 'legendary',
            damage: 50,
        },
        {
            spellID: 77,
            name: 'Seahorse water explosion',
            radius: 50,
            rarity: 'rare',
            damage: 50,
        },
    ]
};
const waterSpraySpells = {
    skeleton: {
        'name': 'Water Spray',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 3,
        'speed': 150,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 3,
        'spread': 0,
        'randomSpreadFactor': 0,
        'bulletDelay': 0,
        perBulletDelay: 100,
        'chargeCooldown': null,
        'damage': 8,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'water-cast',
            'impact': 'water-impact',
        },
        'imgPath': 'splashy-stream.png',
        spriteName: 'projectile8'
    },
    variations: [
        {
            spellID: 101,
            rarity: 'uncommon',
            damage: 8
        },
        {
            spellID: 102,
            rarity: 'rare',
            damage: 14
        },
        {
            spellID: 103,
            rarity: 'epic',
            damage: 18
        },
        {
            spellID: 104,
            rarity: 'legendary',
            damage: 21
        },
        {
            spellID: 105,
            name: 'Ice Spray',
            rarity: 'rare',
            radius: 6,
            effect: ['slow'],
            damage: 7,
            'audio': audio.frostbolt,
            'imgPath': 'triple-ice-bolt.png',
            'spriteName': 'projectile19',
        },
        {
            spellID: 106,
            name: 'Ice Spray',
            rarity: 'epic',
            radius: 6,
            effect: ['slow'],
            damage: 14,
            'audio': audio.frostbolt,
            'imgPath': 'triple-ice-bolt.png',
            'spriteName': 'projectile19',
        },
        {
            spellID: 107,
            name: 'Ice Spray',
            rarity: 'legendary',
            radius: 6,
            effect: ['slow'],
            damage: 17,
            'audio': audio.frostbolt,
            'imgPath': 'triple-ice-bolt.png',
            'spriteName': 'projectile19',
        },
        {
            spellID: 446,
            name: 'Water Spray Enemy',
            rarity: 'uncommon',
            damage: 5
        },
        {
            spellID: 449,
            name: 'Ice Spray Enemy',
            rarity: 'rare',
            radius: 6,
            effect: ['slow'],
            damage: 10,
            'audio': audio.frostbolt,
            'imgPath': 'triple-ice-bolt.png',
            'spriteName': 'projectile19',
        },
    ]
};
const iceNovaSpells = {
    skeleton: {
        'name': 'Ice Nova',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 33,
        'speed': 0,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'self',
        'chargeCooldown': 0,
        'selfDamage': 0,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': {
            'cast': 'frostbolt-2',
            'impact': 'frostbolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'ice-nova.png',
        'spriteName': 'explosion5',
    },
    variations: [
        {
            spellID: 9,
            rarity: 'epic',
            damage: 28
        },
        {
            spellID: 42,
            rarity: 'legendary',
            damage: 35,
            radius: 40,
        },
        {
            spellID: 41,
            rarity: 'Charlie taunt',
            damage: 35,
            radius: 60,
        },
    ]
};
const waterBlastSpells = {
    skeleton: {
        'name': 'Water Blast',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 3,
        'speed': 100,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 5,
        'spread': 72,
        'chargeCooldown': null,
        'damage': 6,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'bubble',
            'impact': 'bubble-pop',
        },
        'imgPath': 'splash.png',
        atlas: true,
        'spriteName': 'bubble.png',
        'noAnim': true
    },
    variations: [
        {
            spellID: 97,
            rarity: 'uncommon'
        },
        {
            spellID: 98,
            rarity: 'rare',
            damage: 10
        },
        {
            spellID: 960,
            rarity: 'rare',
            damage: 10,
            bullets: 3,
        },
    ]
};
const swimmingAuraSpells = {
    skeleton: {
        'name': 'Swimming Aura',
        'mana': 'water',
        'manaCost': 5,
        'tier': 'normal',
        'radius': 6,
        'speed': 0,
        maxDistance: 100,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'aura',
        'effect': 'swimmingAura',
        'effectImpact': 0.7,
        'effectDuration': 30,
        'chargeCooldown': null,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'water_buff',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'waves.png',
    },
    variations: [
        {
            spellID: 600,
            rarity: 'uncommon',
            'effectImpact': 0.7,
        },
        {
            spellID: 601,
            rarity: 'rare',
            'effectImpact': 0.8,
        },
        {
            spellID: 602,
            rarity: 'epic',
            'effectImpact': 0.93,
        },
        {
            spellID: 603,
            rarity: 'legendary',
            'effectImpact': 1.2,
        },
        {
            spellID: 604,
            name: 'Speed buff',
            rarity: 'uncommon',
            'effectImpact': 1.2,
            'effectDuration': 15,
        },
    ]
};
const starfishShotSpells = {
    skeleton: {
        'name': 'Starfish shot',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 3,
        'speed': 100,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 5,
        'spread': 72,
        'chargeCooldown': null,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'bubble',
            'impact': 'bubble-pop',
        },
        'imgPath': 'splash.png',
        atlas: true,
        'spriteName': 'bubble.png',
        'noAnim': true
    },
    variations: [
        {
            spellID: 99,
            rarity: 'epic',
            damage: 15,
        },
        {
            spellID: 100,
            rarity: 'legendary',
            damage: 20
        },
        {
            spellID: 424,
            name: 'Starfish Shot',
            rarity: 'rare',
            damage: 5,
            spellCooldown: 1.5,
            bullets: 5,
            spread: 72,
        },
        {
            spellID: 455,
            name: 'Piranha Starfish Shot',
            rarity: 'epic',
            damage: 15,
            spellCooldown: 2.5,
            bullets: 20,
            spread: 18,
        },
    ]
};
const baseMeleeSpells = {
    skeleton: {
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        'radius': 10,
        'speed': null,
        'spellCooldown': .35,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 5,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'punch',
        },
        'imgPath': 'punch.png',
        'handsFrame': 'default',
    },
    variations: [
        {
            spellID: 12,
            name: 'Punch',
            rarity: 'common'
        },
        {
            spellID: 418,
            name: 'Slime Headbutt',
            rarity: 'common',
            radius: 10,
            spellCooldown: 0.8,
            damage: 5,
        },
        {
            spellID: 477,
            name: 'Slime Boss Headbutt',
            rarity: 'common',
            radius: 10,
            spellCooldown: 0.8,
            damage: 10,
        },
        {
            spellID: 426,
            name: 'Normal Crab Melee Attack',
            rarity: 'rare',
            radius: 10,
            spellCooldown: 0.8,
            damage: 15,
        },
        {
            spellID: 400,
            name: 'evilCreatureClaw',
            rarity: 'rare',
            radius: 20,
            spellCooldown: 0.2,
            damage: 5,
        },
        {
            spellID: 414,
            name: 'evilCreatureBossClaw',
            rarity: 'rare',
            radius: 40,
            spellCooldown: 0.7,
            damage: 15,
        },
        {
            spellID: 417,
            name: 'tinyEvilCreatureBossClaw',
            rarity: 'rare',
            radius: 6,
            spellCooldown: 0.2,
            damage: 4,
        },
        {
            spellID: 401,
            name: 'leopardMelee',
            rarity: 'rare',
            radius: 15,
            spellCooldown: 0.8,
            damage: 15,
        },
        {
            spellID: 408,
            name: 'kingLeopardMelee',
            rarity: 'rare',
            radius: 15,
            spellCooldown: 2,
            damage: 30,
        },
        {
            spellID: 427,
            name: 'Melee Boss Melee Attack',
            rarity: 'rare',
            radius: 50,
            spellCooldown: 0.8,
            damage: 30,
        },
        {
            spellID: 430,
            name: 'Hellhound Swipe',
            rarity: 'rare',
            radius: 25,
            spellCooldown: 0.7,
            damage: 25,
        },
        {
            spellID: 442,
            name: 'Superior Crab Melee',
            rarity: 'rare',
            radius: 20,
            spellCooldown: 0.8,
            damage: 25,
        },
        {
            spellID: 443,
            name: 'Crab Boss Melee',
            rarity: 'rare',
            radius: 20,
            spellCooldown: 0.8,
            damage: 35,
        },
        {
            spellID: 457,
            name: 'Normal Mammoth Swipe',
            rarity: 'rare',
            radius: 25,
            spellCooldown: 0.7,
            damage: 15,
        },
        {
            spellID: 458,
            name: 'Superior Mammoth Swipe',
            rarity: 'rare',
            radius: 25,
            spellCooldown: 0.7,
            damage: 20,
        },
        {
            spellID: 462,
            name: 'JackoCharlie Claw',
            rarity: 'rare',
            radius: 40,
            spellCooldown: 0.7,
            damage: 20,
        },
        {
            spellID: 454,
            name: 'Piranha Boss Attack',
            rarity: 'rare',
            radius: 15,
            spellCooldown: 0.8,
            damage: 25,
        },
    ]
};
const fireStaffs = {
    skeleton: {
        'name': 'Fire Staff',
        'rarity': 'common',
        'dropType': 'staff',
        'mana': 'fire',
        'manaCost': null,
        'tier': 'normal',
        'radius': 6,
        'speed': 200,
        'spellCooldown': 0.67,
        'cooldownCounter': 0,
        'bullets': 2,
        'spread': 7,
        'type': 'melee',
        'type2': 'multi',
        'chargeCooldown': null,
        'damage': 3,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
            'cast': 'firebolt-cast',
            'swoosh': 'firebolt-travel',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'fire-staff.png',
        'spriteName': 'Staff_256_08.png',
        'spellSpriteName': 'projectile15',
        'xOffset': 20,
        'yOffset': -25,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.3,
        'tweenSprite': true,
        'startingWeaponAngle': 40,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 115,
        'tweenHandRotation': 210,
        'tweenXOffset': 10,
        'tweenYOffset': 15,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    variations: [
        {
            spellID: 248,
            rarity: 'common',
            damage: 3,
            tier: 0,
        },
        {
            spellID: 249,
            rarity: 'uncommon',
            damage: 4,
            tier: 1,
        },
        {
            spellID: 250,
            rarity: 'uncommon',
            damage: 5,
            tier: 2
        },
        {
            spellID: 251,
            rarity: 'uncommon',
            damage: 8,
            tier: 3
        },
        {
            spellID: 252,
            rarity: 'uncommon',
            damage: 12,
            tier: 4
        },
        {
            spellID: 253,
            rarity: 'rare',
            damage: 16,
            tier: 5
        },
        {
            spellID: 254,
            rarity: 'rare',
            damage: 16,
            tier: 6
        },
        {
            spellID: 255,
            rarity: 'rare',
            damage: 16,
            tier: 7
        },
        {
            spellID: 256,
            rarity: 'epic',
            damage: 16,
            tier: 8
        },
        {
            spellID: 257,
            rarity: 'epic',
            damage: 16,
            tier: 9
        },
    ]
};
const fireWands = {
    skeleton: {
        'spellID': 231,
        'name': 'Fire Wand',
        'rarity': 'common',
        'dropType': 'wand',
        'mana': 'fire',
        'manaCost': null,
        'tier': 'normal',
        'type': 'melee',
        'chargeCooldown': null,
        'radius': 6,
        'speed': 200,
        'spellCooldown': 0.5,
        'cooldownCounter': 0,
        'type2': 'projectile',
        'damage': 5,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
            'cast': 'firebolt-cast',
            'swoosh': 'firebolt-travel',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'orb-wand.png',
        'spriteName': 'Staff_256_16.png',
        'spellSpriteName': 'projectile15',
        'xOffset': 20,
        'yOffset': -25,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.3,
        'tweenSprite': true,
        'startingWeaponAngle': 40,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 115,
        'tweenHandRotation': 210,
        'tweenXOffset': 10,
        'tweenYOffset': 15,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    variations: [
        {
            spellID: 231,
            rarity: 'common',
            damage: 5,
            tier: 0,
        },
        {
            spellID: 232,
            rarity: 'uncommon',
            damage: 6,
            tier: 1,
        },
        {
            spellID: 233,
            rarity: 'uncommon',
            damage: 9,
            tier: 2,
        },
        {
            spellID: 234,
            rarity: 'uncommon',
            damage: 14,
            tier: 3,
        },
        {
            spellID: 235,
            rarity: 'uncommon',
            damage: 18,
            tier: 4,
        },
        {
            spellID: 236,
            rarity: 'rare',
            damage: 24,
            tier: 5,
        },
        {
            spellID: 237,
            rarity: 'rare',
            damage: 30,
            tier: 6,
        },
        {
            spellID: 238,
            rarity: 'rare',
            damage: 34,
            tier: 7,
        },
        {
            spellID: 239,
            rarity: 'epic',
            damage: 38,
            tier: 8,
        },
        {
            spellID: 240,
            rarity: 'epic',
            damage: 44,
            tier: 9,
        },
    ]
};
const fireSplashSpells = {
    skeleton: {
        'spellID': 110,
        'name': 'Fire Splash',
        'rarity': 'common',
        'castAtPointer': true,
        'mana': 'fire',
        'manaCost': 1,
        'tier': 'normal',
        'radius': 3,
        'speed': 225,
        'spellCooldown': 0.4,
        'cooldownCounter': 0,
        'duration': 0.3,
        'bullets': 24,
        'spread': 15,
        'randomSpreadFactor': 0,
        'bulletDelay': 0,
        'type': 'multi',
        'chargeCooldown': null,
        'damage': 2,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'firebolt-cast',
            'swoosh': 'firebolt-travel',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'fireshot.png',
        'spriteName': 'projectile15',
        dropType: 'spell'
    },
    variations: [
        {
            spellID: 800,
            rarity: 'common',
            damage: 2,
            tier: 0,
            resourceCost: {
                resource: 'mana',
                cost: 20
            }
        },
        {
            spellID: 801,
            rarity: 'uncommon',
            damage: 3,
            tier: 1,
            resourceCost: {
                resource: 'mana',
                cost: 30
            }
        },
        {
            spellID: 802,
            rarity: 'uncommon',
            damage: 4,
            tier: 2,
            resourceCost: {
                resource: 'mana',
                cost: 40
            }
        },
        {
            spellID: 803,
            rarity: 'rare',
            damage: 5,
            tier: 3,
            resourceCost: {
                resource: 'mana',
                cost: 50
            }
        },
        {
            spellID: 804,
            rarity: 'rare',
            damage: 3,
            tier: 4,
            resourceCost: {
                resource: 'mana',
                cost: 60
            }
        },
        {
            spellID: 805,
            rarity: 'epic',
            damage: 3,
            tier: 5,
            resourceCost: {
                resource: 'mana',
                cost: 70
            }
        },
        {
            spellID: 806,
            rarity: 'legendary',
            damage: 3,
            tier: 6,
            resourceCost: {
                resource: 'mana',
                cost: 80
            }
        },
    ]
};
const petSpells = {
    skeleton: {
        'name': 'Pet Spells',
        'mana': 'water',
        'rarity': 'common',
        'manaCost': 5,
        'tier': 'normal',
        'radius': 6,
        'speed': 0,
        maxDistance: 100,
        damage: 0,
        bullets: 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'aura',
        'effect': 'swimmingAura',
        'effectImpact': 0.7,
        'effectDuration': 0.1,
        'chargeCooldown': null,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'water_buff',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'waves.png',
    },
    variations: [
        {
            spellID: 9000,
            name: 'Pet Spell Base',
            // damage: 0,
            // bullets: 0,
            // speed: 150,
            spellCooldown: 2.5,
            // effectDuration: 0,
            // effects: [],
            rarity: 'uncommon',
            // 'noAnim': true,
            imgPath: 'bubbles.png',
            // atlas: true,
            // 'spellSpriteName': 'bubble.png',
        },
    ]
};
const petStaffs = {
    skeleton: {
        'name': 'Pet Command',
        'rarity': 'uncommon',
        'dropType': 'staff',
        'mana': 'fire',
        'manaCost': null,
        'tier': 'normal',
        // spawnOffset: 10,
        'radius': 3,
        // 'speed': 200,
        'speed': 0,
        'spellCooldown': 0.67,
        'cooldownCounter': 0,
        // 'bullets': 0,
        // 'spread': 7,
        // 'type': 'melee',
        'type': 'static',
        // 'type2': 'static',
        'chargeCooldown': 0.5,
        // 'staticFrame': 0,
        // duration: 0.5,
        // 'bulletDelay': 0,
        'castAtPointer': true,
        // 'xDistanceRange': { min: 1, max: 200 },
        // 'yDistanceRange': { min: 1, max: 200 },
        'damage': 3,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            // 'cast': null,
            'prep': 'bubble-pop',
            // 'swing': 'sword-swing',
            'swing': 'punch',
            // 'cast': 'gravity-cast',
            // 'swoosh': 'firebolt-travel',
            // 'impact': 'bubble-pop',
        },
        // 'imgPath': 'fire-staff.png',
        'imgPath': '../../spellsSingle/selection.png',
        // 'spriteName': 'Staff_256_08.png',
        playImmediately: true,
        listenToEntityClicks: true,
        // 'spriteName': 'explosion4',
        atlas: true,
        'spriteName': 'selection.png',
        'noAnim': true,
        showOnlyToOwner: true,
        scale: {
            scaleX: 1.15,
            scaleY: 1.15,
            duration: 600,
            repeat: 0,
            yoyo: true
        },
        // spin: 300,
        // 'spellSpriteName': 'bubble.png',
        // 'xOffset': 20,
        // 'yOffset': -25,
        // 'sheathedXOffset': -12,
        // 'sheathedYOffset': -25,
        // 'sheathedRotation': 0,
        // 'weaponScale': 0.3,
        // 'tweenSprite': true,
        // 'startingWeaponAngle': 40,
        // 'startingHandAngle': 0,
        // 'tweenWeaponRotation': 115,
        // 'tweenHandRotation': 210,
        // 'tweenXOffset': 10,
        // 'tweenYOffset': 15,
        // 'tweenForwardDuration': 150,
        // 'tweenBackwardDuration': 150,
        // 'handsFrame': 'veryNarrow',
        // handsTweenLeft: { x: 10, y: Constants.PLAYER_SIZE.body - 20 },
        // handsTweenRight: { x: -10, y: Constants.PLAYER_SIZE.body - 20 },
    },
    variations: [
        {
            spellID: 10010,
            rarity: 'uncommon',
            damage: 3,
            // tier: 0,
            // radius: 3.5,
            conditions: [
                {
                    type: 'clickOption',
                    clickOption: 'enemy', // 'enemy' | 'player' | 'otherPlayer',
                    result: [
                        {
                            type: 'altSpell',
                            altSpellID: 10011, // single alternative spell using ID
                        },
                    ],
                    // altSpell?: Spell, // single alternative spell using spell object
                },
                {
                    type: 'clickOption',
                    clickOption: 'otherPlayer',
                    result: [
                        {
                            type: 'altSpell',
                            altSpellID: 10011, // single alternative spell using ID
                        },
                    ],
                },
            ],
        },
        {
            spellID: 10011,
            rarity: 'uncommon',
            damage: 3,
            'spriteName': 'attack.png',
            // radius: 4
            // radius:4,
            conditions: [
                {
                    type: 'clickOption',
                    clickOption: 'enemy', // 'enemy' | 'player' | 'otherPlayer',
                    result: [
                        {
                            type: 'replaceProps',
                            replaceProp: [
                                {
                                    prop: 'trackEntity',
                                    value: true,
                                },
                                {
                                    prop: 'wrapEntity',
                                    value: true,
                                },
                                {
                                    prop: 'limitWrapSize',
                                    value: true,
                                },
                            ],
                        },
                    ],
                    // altSpell?: Spell, // single alternative spell using spell object
                },
                {
                    type: 'clickOption',
                    clickOption: 'otherPlayer', // otherPlayer?
                    result: [
                        {
                            type: 'replaceProps',
                            replaceProp: [
                                {
                                    prop: 'trackEntity',
                                    value: true,
                                },
                                {
                                    prop: 'wrapEntity',
                                    value: true,
                                },
                            ],
                        },
                    ],
                },
            ],
        }
    ]
};
const shotguns = {
    skeleton: {
        'name': 'Shotgun',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        // spawnOffset: 7,
        spawnOffsetX: 17,
        spawnOffsetY: 7,
        'radius': 4,
        speed: 200,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'melee',
        'type2': 'multi',
        // isSpear: true,
        'chargeCooldown': null,
        'damage': 30,
        bullets: 6,
        // spread: 5,
        spread: 2,
        randomSpreadFactor: 3,
        maxDistance: 100,
        randomBulletDelay: { min: 0, max: 50 },
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'sawed-off-shotgun.png',
        // spriteName: 'shotgun.png',
        'spriteName': 'shotgun.png',
        'spellSpriteName': 'projectile25',
        animSettings: spellAnimSettings_1.animSettings.shotgun,
        'dropType': 'staff',
        // atlas: true
    },
    variations: [
        {
            spellID: 260,
            rarity: 'uncommon'
        },
    ]
};
const snipers = {
    skeleton: {
        'name': 'Sniper',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        // spawnOffset: 7,
        spawnOffsetX: 17,
        spawnOffsetY: 7,
        'radius': 4,
        speed: 400,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'melee',
        'type2': 'projectile',
        // isSpear: true,
        'chargeCooldown': null,
        'damage': 150,
        // bullets: 6,
        // spread: 5,
        // spread: 2,
        // randomSpreadFactor: 3,
        // maxDistance: 500,
        // randomBulletDelay: { min: 0, max: 50 },
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'winchester-rifle.png',
        // spriteName: 'shotgun.png',
        'spriteName': 'sniper.png',
        'spellSpriteName': 'projectile25',
        animSettings: spellAnimSettings_1.animSettings.shotgun,
        'dropType': 'staff',
        // atlas: true
    },
    variations: [
        {
            spellID: 270,
            rarity: 'uncommon'
        },
    ]
};
const miniguns = {
    skeleton: {
        'name': 'Minigun',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        // spawnOffset: 7,
        spawnOffsetX: 17,
        spawnOffsetY: 7,
        // 'radius': 3,
        'radius': 4,
        speed: 200,
        // 'spellCooldown': 0.15,
        'spellCooldown': 0.3,
        // 'spellCooldown': 0.05,
        'cooldownCounter': 0,
        'type': 'melee',
        'type2': 'multi',
        // isSpear: true,
        'chargeCooldown': null,
        // 'damage': 0.01,
        // 'damage': 5,
        // damage: 20,
        damage: 65,
        // 'damage': 500,
        // bullets: 2,
        bullets: 1,
        // spread: 5,
        spread: 1,
        randomSpreadFactor: 7,
        // maxDistance: 500,
        randomBulletDelay: { min: 0, max: 75 },
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'machine-gun.png',
        'spriteName': 'minigun.png',
        'spellSpriteName': 'projectile25',
        // noAnim: true,
        animSettings: spellAnimSettings_1.animSettings.shotgun,
        'dropType': 'staff',
        maxDistance: 150,
        // atlas: true
    },
    variations: [
        {
            spellID: 280,
            rarity: 'rare'
        },
    ]
};
const burstRifles = {
    skeleton: {
        'name': 'Burst Rifle',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        // spawnOffset: 7,
        spawnOffsetX: 17,
        spawnOffsetY: 7,
        'radius': 3,
        speed: 200,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'melee',
        'type2': 'multi',
        // isSpear: true,
        'chargeCooldown': null,
        'damage': 40,
        bullets: 3,
        // spread: 5,
        spread: 0,
        // randomSpreadFactor: 5,
        // maxDistance: 500,
        // randomBulletDelay: { min: 0, max: 50 },
        perBulletDelay: 50,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'famas.png',
        // spriteName: 'shotgun.png',
        'spriteName': 'assault.png',
        'spellSpriteName': 'projectile25',
        animSettings: spellAnimSettings_1.animSettings.shotgun,
        'dropType': 'staff',
        maxDistance: 200,
        // atlas: true
    },
    variations: [
        {
            spellID: 290,
            rarity: 'uncommon'
        },
    ]
};
const template = {
    skeleton: {},
    variations: [
        {
            spellID: 1,
            rarity: 'uncommon'
        }
    ]
};
const spellsToGen = [
    //spells (both player and enemy)
    bubbleSpells,
    meteorSpells,
    bindingShotSpells,
    darkHoleSpells,
    healingCircleSpells,
    iceBoltSpells,
    fireballSpells,
    fireSpraySpells,
    windBoltSpells,
    earthquakeSpells,
    gravityBallSpells,
    fireChasmSpells,
    wrathSpells,
    explodeSpells,
    waterSpraySpells,
    waterBlastSpells,
    iceNovaSpells,
    swimmingAuraSpells,
    starfishShotSpells,
    fireSplashSpells,
    //weapons
    daggers,
    spears,
    swords,
    baseMeleeSpells,
    fireStaffs,
    fireWands,
    shotguns,
    snipers,
    miniguns,
    burstRifles,
    //movement
    dashSpells,
    teleportSpells,
    chargeSpells,
    stealthSpells,
    //misc
    netSpells,
    petSpells,
    petStaffs,
];
exports.spellsBase = [
    {
        'spellID': 7,
        'name': 'Implode',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 30,
        'speed': 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'self',
        'staticFrame': 2,
        'chargeCooldown': 0.75,
        'damage': 35,
        'selfDamage': 5,
        'speedBoost': null,
        'sprintTicks': null,
        'lockPlayer': true,
        'effects': ['gravity'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'firebolt-explode',
            'prep': 'implode-cast',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3',
    },
    {
        'spellID': 59,
        'name': 'Earthball',
        'rarity': 'rare',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 6,
        'speed': 200,
        'spellCooldown': 0.5,
        'cooldownCounter': 0,
        'type': 'projectile',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['root'],
        'effectsDuration': { root: 120 },
        'audio': audio.fireball,
        'imgPath': 'fireball.png',
        'spriteName': 'projectile25',
    },
    {
        'spellID': 110,
        'name': 'Fire Splash',
        'rarity': 'common',
        'castAtPointer': true,
        'mana': 'fire',
        'manaCost': 1,
        'tier': 'normal',
        'radius': 3,
        'speed': 225,
        'spellCooldown': 0.4,
        'cooldownCounter': 0,
        'duration': 0.3,
        'bullets': 24,
        'spread': 15,
        'randomSpreadFactor': 0,
        'bulletDelay': 0,
        'type': 'multi',
        'chargeCooldown': null,
        'damage': 2,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'firebolt-cast',
            'swoosh': 'firebolt-travel',
            'impact': 'firebolt-explode',
        },
        'imgPath': 'fireshot.png',
        'spriteName': 'projectile15',
    },
    // 200's
    {
        'spellID': 202,
        'name': 'Ice Katana',
        'rarity': 'epic',
        'mana': 'water',
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 10,
        'radius': 27,
        'speed': null,
        'spellCooldown': 0.38,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': {
            'swing': 'sword-swing'
        },
        'imgPath': 'water-katana.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_18',
        animSettings: spellAnimSettings_1.animSettings.katana
    },
    {
        'spellID': 203,
        'name': 'Wind Katana',
        'rarity': 'epic',
        'mana': 'air',
        'manaCost': null,
        'tier': 'normal',
        // 'radius': 17,
        spawnOffset: 10,
        'radius': 27,
        'speed': null,
        'spellCooldown': 0.38,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 11,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['knockback'],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'air-katana.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_17',
        animSettings: spellAnimSettings_1.animSettings.katana
    },
    {
        'spellID': 204,
        'name': 'Ice Staff',
        'rarity': 'epic',
        'dropType': 'staff',
        'mana': 'water',
        'manaCost': null,
        'tier': 'normal',
        'radius': 8,
        'speed': null,
        'spellCooldown': 0.6,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'ice-staff.png',
        'spriteName': 'ice-staff',
        'xOffset': 20,
        'yOffset': -50,
        'sheathedXOffset': -12,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.2,
        'tweenSprite': true,
        'startingWeaponAngle': 40,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 130,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    {
        'spellID': 205,
        'name': 'Fire Staff',
        'rarity': 'epic',
        'mana': 'fire',
        'manaCost': null,
        'tier': 'normal',
        'radius': 8,
        'speed': null,
        'spellCooldown': 0.6,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'fire-staff.png',
        'spriteName': 'fire-staff',
        animSettings: spellAnimSettings_1.animSettings.staff
    },
    {
        'spellID': 206,
        'name': 'Air Staff',
        'rarity': 'epic',
        'dropType': 'staff',
        'mana': 'air',
        'manaCost': null,
        'tier': 'normal',
        'radius': 8,
        'speed': null,
        'spellCooldown': 0.6,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 10,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['knockback'],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'air-staff.png',
        'spriteName': 'air-staff',
        'xOffset': 20,
        'yOffset': -50,
        'sheathedXOffset': -20,
        'sheathedYOffset': -25,
        'sheathedRotation': 0,
        'weaponScale': 0.2,
        'tweenSprite': true,
        'startingWeaponAngle': 40,
        'startingHandAngle': 0,
        'tweenWeaponRotation': 130,
        'tweenHandRotation': 90,
        'tweenXOffset': 53,
        'tweenYOffset': 25,
        'tweenForwardDuration': 150,
        'tweenBackwardDuration': 150,
        'handsFrame': 'veryNarrow',
        handsTweenLeft: { x: 10, y: constants_1.default.PLAYER_SIZE.body - 20 },
        handsTweenRight: { x: -10, y: constants_1.default.PLAYER_SIZE.body - 20 },
    },
    {
        'spellID': 207,
        'name': 'Moonblade',
        'rarity': 'legendary',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 33,
        'speed': null,
        'spellCooldown': 0.6,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 28,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'broadsword.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_10',
        animSettings: spellAnimSettings_1.animSettings.moonblade
    },
    {
        'spellID': 210,
        'name': 'Morning Star',
        'rarity': 'uncommon',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 25,
        'speed': null,
        'spellCooldown': 1.5,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 35,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'morningStar.png',
        spriteName: 'morningStar.png',
        animSettings: spellAnimSettings_1.animSettings.morningStar,
        selfSlow: true,
        selfSlowDuration: 0.35
    },
    {
        'spellID': 213,
        'name': 'Darksword',
        'rarity': 'legendary',
        'mana': 'dark',
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 33,
        'speed': null,
        'spellCooldown': 1,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 45,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['gravity'],
        'audio': {
            'swing': 'sword-swing',
        },
        imgPath: 'dark-sword.png',
        spriteName: 'darkSword.png',
        animSettings: spellAnimSettings_1.animSettings.darkSword,
        selfSlow: true,
        selfSlowDuration: 0.15
    },
    {
        'spellID': 225,
        'name': 'IceBane',
        'rarity': 'legendary',
        'mana': null,
        'manaCost': null,
        'tier': 'normal',
        spawnOffset: 7,
        'radius': 33,
        'speed': null,
        'spellCooldown': 0.6,
        'cooldownCounter': 0,
        'type': 'melee',
        'chargeCooldown': null,
        'damage': 31,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['slow'],
        'audio': {
            'swing': 'sword-swing',
        },
        'imgPath': 'broadsword.png',
        'spriteName': 'swords',
        'atlasTexture': 'Sword sheet_19',
        animSettings: spellAnimSettings_1.animSettings.darkSword
    },
    // 300's Movement Spells
    // 400's
    {
        'spellID': 416,
        'name': 'Dragon Multi Explode',
        'rarity': 'epic',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 27,
        'speed': 0,
        'spellCooldown': 6,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 50, max: 160 },
        'yDistanceRange': { min: 50, max: 160 },
        'bullets': 14,
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 40,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': null,
            'impact': 'firebolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'explode.png',
        'spriteName': 'explosion4red',
        minTimeEngaged: 2,
    },
    {
        'spellID': 419,
        'name': 'Slime boss explosion',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 100,
        'speed': 0,
        'spellCooldown': 20,
        'cooldownCounter': 0,
        'type': 'self',
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['knockback'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'firebolt-explode',
            'prep': 'implode-cast',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3air',
        minTimeEngaged: 7,
    },
    {
        'spellID': 420,
        'name': 'Implode Trap Test',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 30,
        'speed': 0,
        'spellCooldown': 2,
        'cooldownCounter': 0,
        'type': 'self',
        drop: true,
        'staticFrame': 2,
        'chargeCooldown': 0.75,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        // 'lockPlayer': true,
        'effects': ['gravity'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'firebolt-explode',
            'prep': 'implode-cast',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3',
    },
    {
        'spellID': 423,
        'name': 'Dragon explosion',
        'rarity': 'rare',
        'mana': 'dark',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 70,
        'speed': 0,
        'spellCooldown': 20,
        'cooldownCounter': 0,
        'type': 'self',
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 60,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['knockback'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'firebolt-explode',
            'prep': 'water-bubble',
        },
        'imgPath': 'explode.png',
        'spriteName': 'explosion4red',
        minTimeEngaged: 4,
    },
    {
        'spellID': 431,
        'name': 'Melee Boss Multi Gravity',
        'rarity': 'rare',
        'mana': 'earth',
        'manaCost': 10,
        'tier': 'normal',
        'radius': 50,
        'speed': 0,
        'spellCooldown': 12,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 25, max: 60 },
        'yDistanceRange': { min: 25, max: 60 },
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 1600 },
        'bullets': 5,
        'staticFrame': 1,
        'chargeCooldown': 0.5,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['gravity'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'gravity-compress',
            'prep': 'gravity-pull',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3black',
        minTimeEngaged: 5,
    },
    {
        'spellID': 434,
        'name': 'Slime Multi Explode',
        'rarity': 'epic',
        'mana': 'fire',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 27,
        'speed': 0,
        'spellCooldown': 6,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 50, max: 160 },
        'yDistanceRange': { min: 50, max: 160 },
        'bullets': 8,
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': null,
            'impact': 'firebolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'explode.png',
        'spriteName': 'explosion4red',
        minTimeEngaged: 2,
    },
    {
        'spellID': 452,
        'name': 'Slime Multi Explode',
        'rarity': 'epic',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 27,
        'speed': 0,
        'spellCooldown': 6,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 50, max: 160 },
        'yDistanceRange': { min: 50, max: 160 },
        'bullets': 8,
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'frostbolt-2',
            'impact': 'frostbolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'ice-nova.png',
        'spriteName': 'explosion5',
        minTimeEngaged: 2,
    },
    {
        'spellID': 459,
        'name': 'Ice Golem Boss Ice Barrage',
        'rarity': 'epic',
        'mana': 'water',
        'manaCost': 2,
        'tier': 'normal',
        'radius': 27,
        'speed': 0,
        'spellCooldown': 6,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 50, max: 160 },
        'yDistanceRange': { min: 50, max: 160 },
        'bullets': 8,
        'staticFrame': 2,
        'chargeCooldown': 1.5,
        'damage': 25,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': {
            'cast': 'frostbolt-2',
            'impact': 'frostbolt-explode',
            'prep': 'water-bubble'
        },
        'imgPath': 'ice-nova.png',
        'spriteName': 'explosion5',
        minTimeEngaged: 2,
    },
    {
        'spellID': 463,
        'name': 'Melee Boss Multi Gravity',
        'rarity': 'rare',
        'mana': 'earth',
        'manaCost': 10,
        'tier': 'normal',
        'radius': 50,
        'speed': 0,
        'spellCooldown': 12,
        'cooldownCounter': 0,
        'type': 'multiStatic',
        'xDistanceRange': { min: 25, max: 250 },
        'yDistanceRange': { min: 25, max: 250 },
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 500 },
        'bullets': 7,
        'staticFrame': 1,
        'chargeCooldown': 0.5,
        'damage': 15,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': ['gravity'],
        'audio': {
            'cast': 'windbolt-cast',
            'impact': 'gravity-compress',
            'prep': 'gravity-pull',
        },
        'imgPath': 'implode.png',
        'spriteName': 'explosion3black',
        minTimeEngaged: 5,
    },
    {
        'spellID': 466,
        'name': 'Ice Golem Ice Stream',
        'rarity': 'legendary',
        'mana': 'water',
        'manaCost': 3,
        'tier': 'normal',
        'radius': 6,
        'speed': 200,
        'spellCooldown': 4,
        'cooldownCounter': 0,
        'type': 'multi',
        'bullets': 15,
        'spread': .75,
        'randomSpreadFactor': .75,
        'bulletDelay': 0,
        'randomBulletDelay': { min: 0, max: 1000 },
        'chargeCooldown': null,
        'damage': 7,
        'speedBoost': null,
        'sprintTicks': null,
        'effects': [],
        'audio': audio.frostbolt,
        'imgPath': 'triple-ice-bolt.png',
        'spriteName': 'projectile19',
        minTimeEngaged: 3,
    },
];
function generateSpells(spellsToGen) {
    const spells = [];
    spellsToGen.forEach(spellSet => {
        if (spellSet !== petSpells) {
            const spell = spellSet.skeleton;
            spellSet.variations.forEach(variation => {
                const newSpell = Object.assign(Object.assign({}, spell), variation);
                if (variation.tier) {
                    newSpell.name = `T${variation.tier} ${spell.name}`;
                }
                spells.push(newSpell);
            });
        }
        else {
            // Spells for player to use to represent pets
            for (const pet in config_1.petData) {
                if (config_1.petData[pet].petId !== 0) {
                    let id = 9000 + config_1.petData[pet].petId;
                    // let enemyData = EnemyConstants.find(x => x.enemyID === petData[pet].petId)
                    // const petSpell = spells.find((value, index, obj) => value.spellID === enemyData.spells[1])
                    // const petSpell = spells.find(x => {return x.spellID === petData[pet].spells[1]})
                    // console.log('petSpell', petSpell)
                    let spellRarity = 'common';
                    if (config_1.petData[pet].tier === 2) {
                        spellRarity = 'uncommon';
                    }
                    else if (config_1.petData[pet].tier === 3) {
                        spellRarity = 'rare';
                    }
                    petSpells.variations.push({
                        spellID: id, // name: `Player Spell for ${petData[pet].name}`,
                        name: ``,
                        spellCooldown: 1.5,
                        // effectDuration: 0,
                        // effects: [],
                        rarity: spellRarity,
                        // 'noAnim': true,
                        imgPath: config_1.petData[pet].imgPath,
                        // atlas: true,
                        // 'spellSpriteName': 'bubble.png',
                    });
                }
            }
            const spell = spellSet.skeleton;
            spellSet.variations.forEach(variation => {
                const newPetSpell = Object.assign(Object.assign({}, spell), variation);
                spells.push(newPetSpell);
            });
        }
    });
    createGunSpells(280, exports.gunStartingLevels.minigun, spells);
    createGunSpells(270, exports.gunStartingLevels.sniper, spells);
    createGunSpells(290, exports.gunStartingLevels.burstRifle, spells);
    createGunSpells(260, exports.gunStartingLevels.shotgun, spells);
    for (const pet in config_1.petData) {
        if (config_1.petData[pet].name === 'base') {
            continue;
        }
        let id = 9000 + config_1.petData[pet].petId;
        let playerPetSpell = spells.find(x => x.spellID === id); // player spell to add description to
        let tempSpell = spells.find(spell => spell.spellID === config_1.petData[pet].playerPetSpell); // spell cast by pet
        let spellBaseSpell = exports.spellsBase.find(spell => spell.spellID === config_1.petData[pet].playerPetSpell); // spell cast by pet, but not in spells initially
        let spellSet = spellsToGen.find((spellSet) => (spellSet.skeleton.spellID === config_1.petData[pet].playerPetSpell || spellSet.variations.find((variation) => variation.spellID === config_1.petData[pet].playerPetSpell))); // base spellset holding pet spells
        if (spellSet && spellSet.skeleton && spellSet.skeleton.name) {
            playerPetSpell.name = `${config_1.petData[pet].name} ${spellSet.skeleton.name}`;
        }
        else if (tempSpell) {
            playerPetSpell.name = `${tempSpell.name}`;
        }
        else if (spellBaseSpell) {
            playerPetSpell.name = `${spellBaseSpell.name}`;
        }
        else {
            playerPetSpell.name = `Player Spell for ${config_1.petData[pet].name}`;
        }
    }
    return spells;
}
const generatedSpells = generateSpells(spellsToGen);
function createGunSpells(gunId, startingId, spells) {
    let gunSpell = spells.find(x => x.spellID === gunId);
    let starterGunId = startingId;
    for (let i = 0; i < exports.gunLevels; i++) {
        let newGunSpell = Object.assign({}, gunSpell);
        newGunSpell.rarity = 'uncommon';
        newGunSpell.spellID = starterGunId;
        newGunSpell.name = `Level ${i + 1} ${gunSpell.name}`;
        newGunSpell.damage = gunSpell.damage * (i + 2) * 2;
        // newGunSpell.baseDamage = newGunSpell.damage
        spells.push(newGunSpell);
        starterGunId++;
    }
    // superior
    for (let i = 0; i < exports.gunLevels; i++) {
        let newGunSpell = Object.assign({}, gunSpell);
        newGunSpell.rarity = 'rare';
        newGunSpell.spellID = starterGunId;
        newGunSpell.name = `Level ${i + 1} Superior ${gunSpell.name}`;
        newGunSpell.damage = gunSpell.damage * (i + 2) * 2.5;
        // newGunSpell.baseDamage = newGunSpell.damage
        spells.push(newGunSpell);
        starterGunId++;
    }
    // ice
    for (let i = 0; i < exports.gunLevels; i++) {
        let newGunSpell = Object.assign({}, gunSpell);
        newGunSpell.rarity = 'epic';
        newGunSpell.effects = ['slow'];
        newGunSpell.spellID = starterGunId;
        newGunSpell.name = `Level ${i + 1} Ice ${gunSpell.name}`;
        newGunSpell.damage = gunSpell.damage * (i + 2) * 2.5;
        // newGunSpell.baseDamage = newGunSpell.damage
        newGunSpell.spellSpriteName = 'projectile19',
            spells.push(newGunSpell);
        starterGunId++;
    }
    // binding
    for (let i = 0; i < exports.gunLevels; i++) {
        let newGunSpell = Object.assign({}, gunSpell);
        newGunSpell.rarity = 'epic';
        newGunSpell.effects = ['root'];
        newGunSpell.effectsDuration = { root: 15 };
        newGunSpell.spellID = starterGunId;
        newGunSpell.name = `Level ${i + 1} Binding ${gunSpell.name}`;
        newGunSpell.damage = gunSpell.damage * (i + 2) * 2.5;
        // newGunSpell.baseDamage = newGunSpell.damage
        newGunSpell.spellSpriteName = 'projectile9green',
            spells.push(newGunSpell);
        starterGunId++;
    }
    // enhanced 
    for (let i = 0; i < exports.gunLevels; i++) {
        let newGunSpell = Object.assign({}, gunSpell);
        newGunSpell.rarity = 'epic';
        newGunSpell.spellID = starterGunId;
        newGunSpell.name = `Level ${i + 1} Enhanced ${gunSpell.name}`;
        newGunSpell.damage = gunSpell.damage * (i + 2) * 3;
        // newGunSpell.baseDamage = newGunSpell.damage
        spells.push(newGunSpell);
        starterGunId++;
    }
}
// generatedSpells.forEach((spell, index) => {
//     if (spell.tier && typeof spell.tier === 'number')  {
//         let tierKey = `t${spell.tier}`
//         let customCircleColor
//         console.log('spell', spell)
//             if (primarySpells.includes(spell.dropType)) {
//                 customCircleColor = primarySpellColors[tierKey].customCircleColor
//             } else if (secondarySpells.includes(spell.dropType)) {
//                 customCircleColor = secondarySpellColors[tierKey].customCircleColor
//             }
//             if (customCircleColor) {
//                 spell.customCircleColor = customCircleColor
//             }
//     }
// })
generatedSpells.forEach(spell => {
    // if (spell.effects.includes('slow')) {
    //     spell.effects = []
    // }
    if (spell.damage && spell.damage > 0 && (spell.spellID < 2000 || spell.spellID > 6000)) {
        if (spell.type === 'multi') {
            if (spell.bullets) {
                if (spell.spread && spell.spread >= 10) {
                    spell.damage = Math.round(120 / (spell.bullets / 2));
                }
                else if (spell.spread && spell.spread >= 3) {
                    spell.damage = Math.round(Math.max(80, 120 / (spell.bullets / 2)));
                }
                else {
                    spell.damage = Math.round(120 / (spell.bullets)); //Math.max(80, 120/(spell.bullets/2)))
                }
            }
            else {
                spell.damage = 120;
            }
        }
        else if (spell.type === 'melee') {
            spell.damage = 80;
        }
        else {
            spell.damage = 120;
        }
        spell.spellCooldown = 1;
    }
    if (spell.spellID === 10010) {
        spell.damage = 1;
        spell.spellCooldown = 0.2;
    }
    else if (spell.spellID > 9999) {
        spell.damage = 1;
        spell.spellCooldown = 1.5;
    }
});
exports.spells = exports.spellsBase.concat(generatedSpells).map(spell => Object.assign(spell, {
    baseSpellCooldown: spell.spellCooldown,
    baseSpellSpeed: spell.speed,
    baseDamage: spell.damage
})).map(spell => Object.assign(spell, spell.animSettings)).map(spell => {
    return Object.assign(Object.assign({}, spell), { sprintTicks: spell.sprintTicks * (constants_1.default.TICK_RATE / 20) });
});
exports.healingSpellsList = exports.spells.filter(spell => spell.damage < 0).map(spell => spell.spellID);
exports.tauntSpellsList = [41, 429, 422, 467, 444, 447]; //spells.filter(spell => spell.name.includes('taunt')).map(spell => spell.spellID)
